// extracted by mini-css-extract-plugin
export default {"rightPanel":"RightPanel_rightPanel__NfQgx"};